import { useRef, useState } from 'react';

import TeamMember from './TeamMember';
import TeamMemberDialogContent from './TeamMemberDialogContent';
import { TeamMemberFragmentFragment, TeamMembersFragmentFragment } from '../../__generated__/graphql';
import Dialog from '../../components/Dialog';
import Section from '../../layout/Section';
import { ContentBlock } from '../types';

import style from './team-members.module.css';

const TeamMembers: ContentBlock<TeamMembersFragmentFragment> = ({ fragment }) => {
  const dialogRef = useRef<HTMLDialogElement>(null);

  const contentBlockProps = fragment.teamMembers;

  const [selectedMember, setSelectedMember] = useState<null | TeamMemberFragmentFragment>(null);

  const handleSelectMember = (member: TeamMemberFragmentFragment) => {
    setSelectedMember(member);
    dialogRef.current?.showModal();
  };

  if (!contentBlockProps) {
    return null;
  }

  return (
    <>
      <Section
        backgroundColor="black"
        id={contentBlockProps.sectionId}
        innerContainerClassName={style.teamMembers}
      >
        {contentBlockProps.members?.map(member => {
          if (member?.name) {
            return (
              <TeamMember
                key={member.name}
                member={member}
                setSelectedMember={handleSelectMember}
              />
            );
          }
        })}
      </Section>

      <Dialog ref={dialogRef}>
        {selectedMember && (
          <TeamMemberDialogContent member={selectedMember} />
        )}
      </Dialog>
    </>
  );
};

export default TeamMembers;
